import { Data } from "../Types/data";

export const data: Data = {
  "technologies": [
    {
      "id": 1,
      "name": "AEB - Automatic Emergency Braking",
      "description": "Automatic Emergency Braking",
      "unitCost": 600
    },
    {
      "id": 2,
      "name": "ACC - Adaptive Cruise Control",
      "description": "Adaptive Cruise Control",
      "unitCost": 700
    },
    {
      "id": 3,
      "name": "FCW - Forward Collision Warnings",
      "description": "Forward Collision Warnings",
      "unitCost": 1700
    },
    {
      "id": 4,
      "name": "LDW - Lane Departure Warnings",
      "description": "Lane Departure Warnings",
      "unitCost": 2597
    },
    {
      "id": 5,
      "name": "BSM - Blind Spot Monitoring",
      "description": "Blindspot Monitoring System",
      "unitCost": 547
    },
    {
      "id": 6,
      "name": "LKA - Lane Keep Assist",
      "description": "Lane-keeping Assist",
      "unitCost": 2136
    },
    {
      "id": 7,
      "name": "LCA - Lane-Centering Assist",
      "description": "Lane-centering Assist",
      "unitCost": 1083
    },
    {
      "id": 8,
      "name": "Adaptive Steering",
      "unitCost": 1681
    },
    {
      "id": 9,
      "name": "Road-facing Cameras",
      "unitCost": 539
    },
    {
      "id": 10,
      "name": "Driver-facing Cameras",
      "unitCost": 652
    },
    {
      "id": 11,
      "name": "Camera-based Mirror System",
      "unitCost": 1491
    }
  ],
  "variables": [
    {
      "id": 1,
      "name": "Depreciation1",
      "value": 33.33,
      "type": "percentage",
      "description": "First year depreciation"
    },
    {
      "id": 2,
      "name": "Depreciation2",
      "value": 44.45,
      "type": "percentage",
      "description": "Second year depreciation"
    },
    {
      "id": 3,
      "name": "Depreciation3",
      "value": 14.81,
      "type": "percentage",
      "description": "Third year depreciation"
    },
    {
      "id": 4,
      "name": "Depreciation4",
      "value": 7.41,
      "type": "percentage",
      "description": "Fourth year depreciation"
    },
    {
      "id": 5,
      "name": "Depreciation5",
      "value": 0,
      "type": "percentage",
      "description": "Fifth year depreciation"
    },
    {
      "id": 6,
      "name": "Maintenance Rate",
      "value": 5,
      "type": "percentage",
      "description": "Could get broken out by technology if we can get more data"
    },
    {
      "id": 7,
      "name": "Driver Benefits",
      "value": 42,
      "type": "percentage",
      "description": "Applied to input driver hourly wage"
    },
    {
      "id": 8,
      "name": "Driver Overhead",
      "value": 27,
      "type": "percentage",
      "description": "Applied to input driver hourly wage"
    },
    {
      "id": 9,
      "name": "Cost of PDO Crash",
      "value": 11400,
      "type": "currency",
      "description": "Sourced from ATRI"
    },
    {
      "id": 10,
      "name": "Cost of Injury Crash",
      "value": 77500,
      "type": "currency",
      "description": "Sourced from ATRI"
    },
    {
      "id": 11,
      "name": "Cost of Fatality Crash",
      "value": 668000,
      "type": "currency",
      "description": "Sourced from ATRI"
    },
    {
      "id": 12,
      "name": "Corporate Tax Rate",
      "value": 35,
      "type": "percentage",
      "description": "Using rate and depreciation methods prior to 2017 TCJA"
    },
    {
      "id": 13,
      "name": "Default PDO Rate",
      "value": 116.9,
      "type": "number",
      "description": "Sourced from FMCSA 2019 https://www.fmcsa.dot.gov/safety/data-and-statistics/trends-table-20-combination-truck-property-damage-only-pdo-crash-6"
    },
    {
      "id": 14,
      "name": "Default Injury Rate",
      "value": 32.1,
      "type": "number",
      "description": "Sourced from FMCSA 2019 https://www.fmcsa.dot.gov/safety/data-and-statistics/trends-table-18-combination-truck-injury-crash-statistics-1999-2019"
    },
    {
      "id": 15,
      "name": "Default Fatality Rate",
      "value": 1.67,
      "type": "number",
      "description": "Sourced from FMCSA 2019 https://www.fmcsa.dot.gov/safety/data-and-statistics/trends-table-16-combination-truck-fatal-crash-statistics-1975-2019"
    },
    {
      "id": 16,
      "name": "Crash Mitigation Effectiveness Default",
      "value": 70,
      "type": "percentage",
      "description": "Could define different values depending on technology"
    },
    {
      "id": 18,
      "name": "Turnover Rate",
      "value": 100,
      "type": "percentage"
    },
    {
      "id": 19,
      "name": "New driver training hours",
      "value": 1,
      "type": "number"
    },
    {
      "id": 20,
      "name": "Number of drivers per truck",
      "value": 1,
      "type": "number"
    },
    {
      "id": 21,
      "name": "Coaching hours per driver annually",
      "value": 2,
      "type": "number"
    },
    {
      "id": 22,
      "name": "Weighted Average Cost of Capital",
      "value": 5,
      "type": "percentage"
    }
  ]
}
